import React from 'react';
import ReactDOM from 'react-dom/client';
import ARDrawer from './components/react-components/Drawer.jsx';
import ARDrawerContent from './components/react-components/ARDrawerContent.jsx';

const initARDrawer = () => {
	const arDrawerRoot = document.getElementById('ar-drawer');

	if (arDrawerRoot && !arDrawerRoot.dataset?.initiallized) {
		ReactDOM.createRoot(arDrawerRoot).render(
			<React.StrictMode>
				<ARDrawer
					title={'AR Drawer'}
					description={
						'Drawer with product augmented reality assets that can be viewed in room.'
					}
					children={(props) => <ARDrawerContent {...props} />}
					direction={'bottom'}
					openEvent={'AR Drawer Open'}
				/>
			</React.StrictMode>
		);
		arDrawerRoot.dataset.initiallized = 'true';
	}
};

export function initReactComponents() {
	try {
		initARDrawer();
	} catch (error) {
		console.error('Error initializing AR Drawer:', error);
	}
}
